function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { frame, cancelFrame } from '../frameloop/frame.mjs';
import { numberValueTypes } from '../value/types/maps/number.mjs';
import { getValueAsType } from '../value/types/utils/get-as-type.mjs';

var MotionValueState = /*#__PURE__*/function () {
  function MotionValueState() {
    _classCallCheck(this, MotionValueState);

    this.latest = {};
    this.values = new Map();
  }

  _createClass(MotionValueState, [{
    key: "set",
    value: function set(name, value, render, computed) {
      var _this = this;

      var useDefaultValueType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var existingValue = this.values.get(name);

      if (existingValue) {
        existingValue.onRemove();
      }

      var onChange = function onChange() {
        var v = value.get();

        if (useDefaultValueType) {
          _this.latest[name] = getValueAsType(v, numberValueTypes[name]);
        } else {
          _this.latest[name] = v;
        }

        render && frame.render(render);
      };

      onChange();
      var cancelOnChange = value.on("change", onChange);
      computed && value.addDependent(computed);

      var remove = function remove() {
        cancelOnChange();
        render && cancelFrame(render);

        _this.values.delete(name);

        computed && value.removeDependent(computed);
      };

      this.values.set(name, {
        value: value,
        onRemove: remove
      });
      return remove;
    }
  }, {
    key: "get",
    value: function get(name) {
      var _this$values$get;

      return (_this$values$get = this.values.get(name)) === null || _this$values$get === void 0 ? void 0 : _this$values$get.value;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _iterator = _createForOfIteratorHelper(this.values.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var value = _step.value;
          value.onRemove();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);

  return MotionValueState;
}();

export { MotionValueState };